<template>
  <v-container fluid py-0>
    <v-row justify="end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="!createDisabled"
            class="mr-3 mb-3"
            v-on="on"
            small
            fab
            dark
            color="primary"
            @click="onCreateAdjustment"
            :disabled="createDisabled"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
        </template>
        <span>Create new Adjustment</span>
      </v-tooltip>
    </v-row>
    <v-card outlined>
      <v-data-table :items="value" :headers="headers">
        <template v-slot:item.createdAt="{ item }">{{
          item.createdAt | formatDate
        }}</template>
        <template v-slot:item.amount="{ item }">{{
          item.amount | priceLabeler
        }}</template>
      </v-data-table>
    </v-card>
    <invoice-adjustment-dialog
      :show="showAdjustmentDialog"
      @close="showAdjustmentDialog = false"
      v-model="adjustment"
      @save="onAdjustmentSave"
    ></invoice-adjustment-dialog>
    <div v-if="debug">
      <code>{{ showAdjustmentDialog }}</code>
    </div>
  </v-container>
</template>

<script>
import InvoiceAdjustmentDialog from "./InvoiceAdjustmentDialog.vue";
export default {
  name: "invoice-adjustments",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    createDisabled: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { InvoiceAdjustmentDialog },

  data() {
    return {
      debug: false,
      adjustment: {},
      showAdjustmentDialog: false,
      headers: [
        {
          text: "Date",
          align: "left",
          value: "createdAt",
          name: "createdAt",
        },
        {
          text: "User",
          align: "left",
          value: "username",
          name: "username",
        },
        {
          text: "Amount",
          align: "left",
          value: "amount",
          name: "amount",
        },
        {
          text: "VAT Code",
          align: "left",
          value: "vatCode",
          name: "vatCode",
        },
        //notes
        {
          text: "Notes",
          align: "left",
          value: "notes",
          name: "notes",
        },
      ],
    };
  },

  methods: {
    onCreateAdjustment() {
      this.showAdjustmentDialog = true;
    },
    onAdjustmentSave(payload) {
      this.showAdjustmentDialog = false;
      this.$emit("create", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoices/InvoiceAdjustments.vue